import { Component, OnInit } from '@angular/core';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { DataLocalStorageService } from '../../Service/dataLocalStorage.service';
import { AlertService } from '../../../services/alert.service';
import { MicroempresarioService } from '../../../microempresario/services/microempresario.service';
import { RouterService } from '../../../services/router.service';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
declare var $: any;

const datosDetalleAprobador = {
  idCliente: null,
  idSolicitud: '',
  idUsuario: null,
};
@Component({
    selector: 'app-ver-detalle-propuesta',
    templateUrl: './ver-detalle-propuesta.component.html',
    styleUrls: ['./ver-detalle-propuesta.component.scss'],
    providers: [NeoIntermediarioFinancieroService, MicroempresarioService],
    standalone: false
})
export class VerDetallePropuestaComponent implements OnInit {
  public detalleSolicitud: any;
  public user;
  idSolicitud: string;
  isDetalle: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private _userIntermediarioService: UserService,
    private _dataLocalStorageService: DataLocalStorageService,
    private alertService: AlertService,
    private _microempresario: MicroempresarioService,
    private _router: RouterService,
    private _sweetAlert:SweetAlertService
  ) {
    this.user = this._userIntermediarioService.getUser();
    this.route.params.subscribe((params: Params) => {
      this.idSolicitud = params['id'];
      datosDetalleAprobador.idSolicitud = params['id'];
      datosDetalleAprobador.idCliente = Number(this.user.idCliente);
      datosDetalleAprobador.idUsuario = Number(this.user.idUsuario);
    });
  }

  ngOnInit(): void {
    this.isDetalle = this.router.url.includes('/verDetallePropuesta') ? true : false;
    this._neoIntermediarioFinancieroService
      .detalleAprobador(datosDetalleAprobador)
      .subscribe(
        (response) => {
          if (response['exitoso'] == true) {
            this.detalleSolicitud = response['data'];
          } else {
            this._sweetAlert.errorModal("Error!",true,'No fue posible cargar los datos');
          }
        },
        (error) => {
          if (this._dataLocalStorageService.getIdSolicitudPendAprobar()) {
            this.router.navigateByUrl(
              '/intermediario/transaccional/aprobarSolicitudes'
            );
          } else if (
            this._dataLocalStorageService.getIdSolicitudPendRevisar()
          ) {
            this.router.navigateByUrl(
              '/intermediario/transaccional/revisarSolicitudes'
            );
          } else {
            this.router.navigateByUrl('/intermediario/home');
          }
        },
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          });
        }
      );
  }

  goBack() {
    this._router.goBack();
  }

  downloadAll() {
    const mymeType = 'application/zip';
    this._microempresario
      .downloadAllFile(this.idSolicitud)
      .subscribe((response: any) => {
        if (response.exitoso) {
          let a = document.getElementById('allFile');
          a.setAttribute(
            'href',
            `data:${mymeType};base64,${response.documentos}`
          );
          a.setAttribute('download', 'documentos.zip');
          a.click();
        }
      });
  }
}
